import SearchBarSmall from './SearchBarSmall.jsx';

export default SearchBarSmall;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/index.js